import React from "react";

// mood: "idle" | "happy" | "celebrating" | "wrong" | "thinking" | "waving"
const MOUTH = {
  idle:        "M 35 60 Q 50 70 65 60",
  happy:       "M 30 58 Q 50 76 70 58",
  celebrating: "M 28 56 Q 50 78 72 56",
  wrong:       "M 33 68 Q 50 56 67 68",
  thinking:    "M 38 63 Q 50 67 60 63",
  waving:      "M 33 61 Q 50 72 67 61",
};

export default function CabiMascot({ mood = "idle", size = 130, className = "" }) {
  const bounce  = mood === "celebrating" || mood === "happy";
  const sad     = mood === "wrong";
  const think   = mood === "thinking";
  const wave    = mood === "waving";
  const celeb   = mood === "celebrating";
  const happyEye = mood === "happy" || mood === "celebrating" || mood === "waving";

  return (
    <div
      className={`inline-block select-none ${bounce ? "cabi-bounce" : ""} ${className}`}
      style={{ width: size, height: size }}
    >
      <style>{`
        @keyframes cabiJump  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }
        @keyframes cabiShake { 0%,100%{transform:rotate(0)}    25%{transform:rotate(-8deg)}  75%{transform:rotate(8deg)} }
        @keyframes cabiPop   { 0%{transform:scale(0.8)} 60%{transform:scale(1.12)} 100%{transform:scale(1)} }
        @keyframes cabiSpin  { from{transform:rotate(0)} to{transform:rotate(360deg)} }
        .cabi-bounce { animation: cabiJump 0.55s ease-in-out infinite; }
        .cabi-shake  { animation: cabiShake 0.4s ease-in-out; }
        .cabi-pop    { animation: cabiPop 0.4s cubic-bezier(.34,1.56,.64,1) both; }
        .cabi-star   { animation: cabiSpin 2s linear infinite; transform-origin:center; }
      `}</style>

      <svg viewBox="0 0 100 115" width={size} height={size} style={{ overflow: "visible" }}>

        {/* Shadow */}
        <ellipse cx="50" cy="112" rx="24" ry="4" fill="rgba(0,0,0,0.12)" />

        {/* Body */}
        <ellipse cx="50" cy="82" rx="24" ry="20" fill="#EE5F2B" />
        <ellipse cx="50" cy="86" rx="16" ry="12" fill="#FF8A5B" />

        {/* Head */}
        <circle cx="50" cy="48" r="30" fill="#EE5F2B" />
        <circle cx="50" cy="50" r="25" fill="#FF7A47" />

        {/* Graduation cap base */}
        <rect x="24" y="22" width="52" height="7" rx="3.5" fill="#1e293b" />
        {/* Cap top */}
        <polygon points="50,8 76,24 50,26 24,24" fill="#0f172a" />
        {/* Tassel string */}
        <line x1="74" y1="22" x2="80" y2="34" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" />
        <circle cx="80" cy="36" r="4" fill="#FFD700" />

        {/* Cheeks */}
        <circle cx="30" cy="58" r="6" fill="#FF4500" opacity="0.25" />
        <circle cx="70" cy="58" r="6" fill="#FF4500" opacity="0.25" />

        {/* Eyes */}
        {happyEye ? (
          <>
            {/* Happy squinted arcs */}
            <path d="M 30 46 Q 37 40 44 46" stroke="#1e293b" strokeWidth="3" fill="none" strokeLinecap="round" />
            <path d="M 56 46 Q 63 40 70 46" stroke="#1e293b" strokeWidth="3" fill="none" strokeLinecap="round" />
          </>
        ) : sad ? (
          <>
            <circle cx="37" cy="47" r="8" fill="white" />
            <circle cx="63" cy="47" r="8" fill="white" />
            <circle cx="37" cy="49" r="4.5" fill="#334155" />
            <circle cx="63" cy="49" r="4.5" fill="#334155" />
            {/* Sad brows */}
            <path d="M 29 39 Q 37 35 43 39" stroke="#1e293b" strokeWidth="2.2" fill="none" strokeLinecap="round" />
            <path d="M 57 39 Q 63 35 71 39" stroke="#1e293b" strokeWidth="2.2" fill="none" strokeLinecap="round" />
          </>
        ) : think ? (
          <>
            <circle cx="37" cy="47" r="8" fill="white" />
            <circle cx="63" cy="47" r="8" fill="white" />
            <circle cx="38" cy="46" r="4.5" fill="#334155" />
            <circle cx="64" cy="46" r="4.5" fill="#334155" />
            <circle cx="39" cy="44" r="1.8" fill="white" />
            <circle cx="65" cy="44" r="1.8" fill="white" />
            {/* Raised one brow */}
            <path d="M 29 38 Q 37 33 43 37" stroke="#1e293b" strokeWidth="2.2" fill="none" strokeLinecap="round" />
            <path d="M 57 37 Q 63 33 71 38" stroke="#1e293b" strokeWidth="2.2" fill="none" strokeLinecap="round" />
          </>
        ) : (
          <>
            <circle cx="37" cy="47" r="8" fill="white" />
            <circle cx="63" cy="47" r="8" fill="white" />
            <circle cx="37" cy="48" r="4.5" fill="#334155" />
            <circle cx="63" cy="48" r="4.5" fill="#334155" />
            <circle cx="38" cy="46" r="1.8" fill="white" />
            <circle cx="64" cy="46" r="1.8" fill="white" />
          </>
        )}

        {/* Beak */}
        <polygon points="50,58 46,64 54,64" fill="#FFD700" />

        {/* Mouth */}
        <path
          d={MOUTH[mood] || MOUTH.idle}
          stroke="#1e293b" strokeWidth="2.5"
          fill="none" strokeLinecap="round"
        />

        {/* Wings */}
        {celeb ? (
          <>
            <ellipse cx="18" cy="78" rx="14" ry="7" fill="#FF7A47" transform="rotate(-50 18 78)" />
            <ellipse cx="82" cy="78" rx="14" ry="7" fill="#FF7A47" transform="rotate(50 82 78)" />
          </>
        ) : wave ? (
          <>
            <ellipse cx="20" cy="82" rx="12" ry="6" fill="#FF7A47" transform="rotate(-15 20 82)" />
            <ellipse cx="80" cy="70" rx="12" ry="6" fill="#FF7A47" transform="rotate(-55 80 70)" />
          </>
        ) : sad ? (
          <>
            <ellipse cx="20" cy="85" rx="12" ry="6" fill="#FF7A47" transform="rotate(10 20 85)" />
            <ellipse cx="80" cy="85" rx="12" ry="6" fill="#FF7A47" transform="rotate(-10 80 85)" />
          </>
        ) : (
          <>
            <ellipse cx="20" cy="82" rx="12" ry="6" fill="#FF7A47" transform="rotate(-8 20 82)" />
            <ellipse cx="80" cy="82" rx="12" ry="6" fill="#FF7A47" transform="rotate(8 80 82)" />
          </>
        )}

        {/* Feet */}
        <ellipse cx="40" cy="101" rx="11" ry="5" fill="#FFD700" />
        <ellipse cx="60" cy="101" rx="11" ry="5" fill="#FFD700" />

        {/* Thinking bubble */}
        {think && (
          <>
            <circle cx="74" cy="34" r="3" fill="white" stroke="#e2e8f0" strokeWidth="1" />
            <circle cx="81" cy="24" r="4.5" fill="white" stroke="#e2e8f0" strokeWidth="1" />
            <circle cx="90" cy="14" r="6" fill="white" stroke="#e2e8f0" strokeWidth="1" />
            <text x="86" y="18" fontSize="7" textAnchor="middle">?</text>
          </>
        )}

        {/* Celebrating stars */}
        {celeb && (
          <>
            <text x="82" y="22" fontSize="13" className="cabi-star">⭐</text>
            <text x="4"  y="32" fontSize="11">✨</text>
            <text x="84" y="55" fontSize="9" >🌟</text>
            <text x="2"  y="60" fontSize="9" >🎉</text>
          </>
        )}
      </svg>
    </div>
  );
}
